import React, { useEffect, useState, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { UrgencyBanner } from './components/UrgencyBanner';
import { PricingSection } from './components/PricingSection';
import { PlanProDetails } from './components/PlanProDetails';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaFooter } from './components/CtaFooter';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState(1);
  useEffect(() => {
    // Meta Pixel - official script injection
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '937331855399019');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StatsBar data-id="element-4" />
        <ModulesSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <UrgencyBanner data-id="element-7" />
        <PricingSection selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} data-id="element-8" />
        <PlanProDetails selectedPlan={selectedPlan} data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
      </main>

      <CtaFooter data-id="element-11" />

      <PurchasePopup data-id="element-12" />
    </div>;
}